/* eslint-disable @typescript-eslint/naming-convention */
export enum reportAttributeTypesEnum {
    name,
    createdBy,
    createdDate,
    modifiedBy,
    modifiedDate
}
